import * as string from "../utils/strings";
import * as time from "../utils/time";

// DATA

// const logObj = {
//   fullLog: {},
//   Years: {}
// }

export function calculateDayForesight() {
  let unfinishedGoals = 0;

  const timeLeft = Object.values(window.fm.goals).reduce((accumulator, goal) => {
    let remaining;

    if (goal.isGoalActive() && goal.isInPeriod()) {
      remaining = Math.max(goal.getTargetForThisPeriod() - goal.practiced_today, 0);

      if (remaining > 0) {
        unfinishedGoals += 1;
      }
    } else {
      remaining = 0;
    }

    return remaining + accumulator;
  }, 0);

  let bufferMins = 5;
  let bufferTotal = unfinishedGoals * bufferMins;
  let finishTime = time.addMins(window.viewQuery.queryDate, timeLeft);
  let finishTimeBuffer = time.addMins(finishTime, bufferTotal);

  return {
    timeLeft: time.minsToHM(timeLeft),
    finishTime: time.timeNoDate(finishTime),
    finishTimeBuffer: time.timeNoDate(finishTimeBuffer),
  };
}

function logSetEachLineDate() {}

export function getGoalIDsFromTag(tagObj) {
  return Object.values(window.fm.goals).filter((goal) => goal.tag == tagObj.name);
}

export function entryHasComment(entryObj) {
  return entryObj.comment != ("" || " " || "." || undefined || null);
}

export function mergeTCHA(arrayOfTCHA) {
  const merged = {};

  for (let obj of arrayOfTCHA) {
    for (let firstKey in obj) {
      // Check if the first key corresponds to a weight or an exercise
      if (obj[firstKey].hasOwnProperty("total")) {
        // Case when the first key is an exercise

        // Initialization of the exercise if not previously encountered
        if (!merged.hasOwnProperty(firstKey)) {
          merged[firstKey] = {
            total: 0,
            highest: -Infinity,
            count: 0,
            avg: 0,
          };
        }

        // Accumulation of stats for the exercise
        const current = obj[firstKey];
        merged[firstKey].total += current.total;
        merged[firstKey].count += current.count;
        merged[firstKey].highest = Math.max(merged[firstKey].highest, current.highest);
      } else {
        // Case when the first key is a weight

        // Initialization of the weight if not previously encountered
        if (!merged.hasOwnProperty(firstKey)) {
          merged[firstKey] = {};
        }

        // Loop through exercises
        for (let exercise in obj[firstKey]) {
          // Initialization of the exercise under the weight if not previously encountered
          if (!merged[firstKey].hasOwnProperty(exercise)) {
            merged[firstKey][exercise] = {
              total: 0,
              highest: -Infinity,
              count: 0,
              avg: 0,
            };
          }

          // Accumulation of stats for the exercise under the weight
          const current = obj[firstKey][exercise];
          merged[firstKey][exercise].total += current.total;
          merged[firstKey][exercise].count += current.count;
          merged[firstKey][exercise].highest = Math.max(merged[firstKey][exercise].highest, current.highest);
        }
      }
    }
  }

  // Calculation of averages
  for (let firstKey in merged) {
    if (merged[firstKey].hasOwnProperty("total")) {
      // Case when the first key is an exercise
      const { total, count } = merged[firstKey];
      merged[firstKey].avg = Math.round(total / count);
    } else {
      // Case when the first key is a weight
      for (let exercise in merged[firstKey]) {
        const { total, count } = merged[firstKey][exercise];
        merged[firstKey][exercise].avg = Math.round(total / count);
      }
    }
  }

  // console.log(merged);
  return merged;
}

function _getUniqueKeys(arr) {
  return arr.reduce((acc, curr) => {
    Object.keys(curr).forEach((key) => {
      if (!acc.hasOwnProperty(key)) {
        acc[key] = true;
      }
    });
    return acc;
  }, {});
}

function _getUniqueSubKeys(arr, key) {
  return arr.reduce((acc, curr) => {
    Object.keys(curr[key]).forEach((subKey) => {
      if (!acc.includes(subKey)) {
        acc.push(subKey);
      }
    });
    return acc;
  }, []);
}

// Comments
// ======================================================
export function parseComments(comment) {
  if (!comment) {
    return;
  } else {
    const link = makeLink(comment, 60);
    const json = string.makeJSONString(comment);

    comment = comment.replace(link.URL, "").replace(json.string, "");

    return `${comment} ${link.element} ${json.code}`;
  }
}

export function extract(thing, from, extracted = "") {
  return (extracted = thing.replace(from, thing));
}

export function makeLink(comment, length, URL_string = "", link = "") {
  if (comment.match(window.regExes.URL)) {
    URL_string = extractURL(comment);
    comment = comment.replace(URL_string, "");
    link = makeLinkTag(URL_string, length);
  }

  return { URL: URL_string, element: link };
}

export function makeLinkTag(theURL, length) {
  return `<a href="${addHTTPStoURL(theURL)}" target="_blank">${truncateURL(theURL, length)}</a>`;
}

export function truncateURL(theURL, length = 60) {
  if (theURL.length > length) {
    let domain = theURL.match(/\w{3,}\.\w{2,}\.\w{2,}/);
    let slugEnd = theURL.match(/\/(?!.*\/\w)[\w?=&/.]*/);
    theURL = `${domain}/[...]${slugEnd}`;
  }
  return theURL;
}

export function addHTTPStoURL(theURL = "") {
  if (!theURL.includes("://")) {
    theURL = theURL.replace(theURL, `https://${theURL}`);
  }
  return theURL;
}

export function extractURL(comment) {
  if (comment.match(window.regExes.URL)) {
    comment = String(comment.match(window.regExes.URL));
  }
  return comment;
}

// Categories
// ======================================================

// Other
// ======================================================

export function getRhythmTag(entry, rhythm) {
  // return just the first tag, as string.
  return entry.tags.find((tag) => {
    return (tag = Object.values(rhythm).includes(tag));
  });
}

export function getRhythmTags(entry, rhythm) {
  // return all the tags, as array of string.
  return entry.tags.filter((tag) => {
    return (tag = Object.values(rhythm).includes(tag));
  });
}

export function filterRhythmTags(entry) {
  // return all the tags, as array of string.
  return entry.tags.filter((tag) => !tag.match(window.regExes.rhythmTag));
}

function doesEntryContainFlowTag(entry) {
  // return true if one of the tags is at window.config.settings.flow level
}

// Data Building

export function getTimeSleptLastNight(wakeObj = {}, riseObj = {}) {
  // get rise time today
  // get wake time today
  // get sleep time last night
  // print out time-slept last night

  if (document.querySelector("body").getAttribute("timespan") == "day") {
    const queryDateObj = Object.entries(window.viewQuery.query).reverse()[0][1]; // first entry // object with this day's data

    if (queryDateObj.length == 0) return undefined;

    const wakeEntry = queryDateObj.entries.filter((entry) => {
      return entry.tags.includes("wake");
    })[0];

    const riseEntry = queryDateObj.entries.filter((entry) => {
      return entry.tags.includes("rise");
    })[0];

    if (wakeEntry) {
      const wakeHM = wakeEntry.start.match(/\d\d/g);
      wakeObj = new Date(1990, 12, 1, wakeHM[0], wakeHM[1]);
    }

    if (riseEntry) {
      const riseHM = riseEntry.start.match(/\d\d/g);
      riseObj = new Date(1990, 12, 1, riseHM[0], riseHM[1]);
    }

    if (wakeEntry && riseEntry && typeof wakeObj != "undefined" && typeof riseObj != "undefined") {
      return Math.abs((wakeObj.getTime() - riseObj.getTime()) / 60 / 1000);
    } else {
      return undefined;
    }
  } else {
    return "";
  }
}

// Unused
// ======================================================
export function _calculateRatios(listofRatios) {
  // receives ['tagname', 'number duration in minutes']
  let list = listofRatios;

  let sum = 0;
  let ratios = []; // will be a list of numbers that add to 100 [ 23, 56, 12]

  //calculate sum

  if (typeof list[0] === "object") {
    for (let x = 0; x < list.length; x++) {
      sum += list[x][1];
    }
  }
  if (typeof list[0] === "number") {
    for (let x = 0; x < list.length; x++) {
      sum += list[x];
    }
  }

  //calculate multiplier
  let multiplier = 100 / sum;

  //calculate ratios
  for (let j = 0; j < list.length; j++) {
    let ratio;
    if (typeof list[0] === "object") {
      ratio = list[j][1] * multiplier;
    }
    if (typeof list[0] === "number") {
      ratio = list[j] * multiplier;
    }
    let num = Number(ratio.toFixed(2));
    if (num !== num) {
      num = 0;
    } // comparing to itself is a way to check if it is NaN.
    ratios.push(num);
  }
  return ratios;
}

export function printGraphDates(datesToDisplay, x) {
  let day = window.ui.dayNamesShort[new Date(datesToDisplay[x]).getDay()];
  let date = new Date(datesToDisplay[x]).getDate();
  let num = String(date).padStart(2, "0");

  if (datesToDisplay.length <= 7) {
    date = `${day} ${num}`;
  }

  // let dateType = "day";
  // document.getElementById(`graph-date`).insertAdjacentHTML("beforeend", `<span class="${dateType}">${date}</span>`);
}
